import { AccessLevel, ProtectedFeature } from '@permissions/models/permissions.models';

export const protectedLivewall: ProtectedFeature[] = [
  {
    feature: 'view_livewall',
    allow: [AccessLevel.Administrator, AccessLevel.Superviser, AccessLevel.Operator, AccessLevel.View],
  },
];
